import React from 'react';

import { Box, Heading, Text, Breadcrumb, Flash, } from '@primer/components'
import { Link } from "react-router-dom";
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import python from 'react-syntax-highlighter/dist/esm/languages/hljs/python';
import {atomOneLight as theme} from 'react-syntax-highlighter/dist/esm/styles/hljs';

import WaveHero from '../components/WaveHero';
import Seo from '../components/Seo'
import Features from '../components/Features'
import CodeReview from '../components/BeforeAfter/BeforeAfterHorizontal'
import { useProduct } from '../hooks/useProduct'
import useAnalytics from '../hooks/useAnalytics'
import RepositorySearch from '../components/RepositorySearch'


SyntaxHighlighter.registerLanguage('python', python);


export default function AbstractRule(props) {
  const productDetails = useProduct()
  const Summary = props.Summary
  const analytics = useAnalytics()

  return (
    <Box>
      <Seo 
        image={props.ogImage}
        title={`${props.title} best practice`}
      />
      <WaveHero>
        <Box className="container-md lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/'} className="text-white">Home</Breadcrumb.Item>
            <Breadcrumb.Item as={Link} to={`${props.urlPrefix}/best-practice/${props.category}`} className="text-white"><span style={{textTransform: 'capitalize'}}>{props.category}</span> best practice</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>{ props.title }</Heading>
        </Box>
      </WaveHero>

      <div className="container-md px-3 mb-6" style={{fontSize: "16px"}}>

      <div className="text-normal">
          <div style={{marginBottom: "30px"}} className="f3">
            <Summary />
          </div>
          { props.explanation && (<div className="f3">{ props.explanation }</div>) }
          { props.exampleBefore &&
            (
              <>
                <Text as="p" className="f3 mb-4">If our <a href={productDetails.gitHubMarketplaceLink} onClick={() => analytics.track('8R4GQ0IT')} target="_blank">GitHub code review bot</a> spots this issue in your pull request it gives this advice:</Text>
                <CodeReview examplesCodes={[props.code]} />
              </>
            )
          }
        </div>
      </div>
      <Box className="container-md mt-8 mb-8 text-center">
        <Box className="position-relative mt-6" onClick={() => analytics.track('JS3AWDTZ')}>
          <Heading className="mb-6">Instantly check if you have this issue for free</Heading>
          <div className="text-left">
            <RepositorySearch />
          </div>
        </Box>
      </Box>
      <Features />
    </Box>
  );
}

AbstractRule.defaultProps = {
  furtherReading: [],
  ogImage: "/default.png"
}
